/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ResponseShipmentPackage } from './ResponseShipmentPackage';
import {
    ResponseShipmentPackageFromJSON,
    ResponseShipmentPackageFromJSONTyped,
    ResponseShipmentPackageToJSON,
    ResponseShipmentPackageToJSONTyped,
} from './ResponseShipmentPackage';
import type { ResponseAmazonItem } from './ResponseAmazonItem';
import {
    ResponseAmazonItemFromJSON,
    ResponseAmazonItemFromJSONTyped,
    ResponseAmazonItemToJSON,
    ResponseAmazonItemToJSONTyped,
} from './ResponseAmazonItem';

/**
 * 
 * @export
 * @interface ResponseGetPlanInfoDetailResponse
 */
export interface ResponseGetPlanInfoDetailResponse {
    /**
     * 
     * @type {Array<ResponseAmazonItem>}
     * @memberof ResponseGetPlanInfoDetailResponse
     */
    amazonItems?: Array<ResponseAmazonItem>;
    /**
     * 
     * @type {number}
     * @memberof ResponseGetPlanInfoDetailResponse
     */
    baseId?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponseGetPlanInfoDetailResponse
     */
    endDate?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponseGetPlanInfoDetailResponse
     */
    groupNum?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseGetPlanInfoDetailResponse
     */
    isApiPlan?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ResponseGetPlanInfoDetailResponse
     */
    phoneNumber?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponseGetPlanInfoDetailResponse
     */
    planId?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponseGetPlanInfoDetailResponse
     */
    planName?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseGetPlanInfoDetailResponse
     */
    readyToShipDate?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseGetPlanInfoDetailResponse
     */
    senderName?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseGetPlanInfoDetailResponse
     */
    shipNum?: string;
    /**
     * 
     * @type {Array<ResponseShipmentPackage>}
     * @memberof ResponseGetPlanInfoDetailResponse
     */
    shipmentBoxes?: Array<ResponseShipmentPackage>;
    /**
     * 
     * @type {string}
     * @memberof ResponseGetPlanInfoDetailResponse
     */
    shipmentConfirmationId?: string;
    /**
     * FbaTransportationInfo FbaTransportationInfo `json:"fba_transportation_info"`
     * @type {string}
     * @memberof ResponseGetPlanInfoDetailResponse
     */
    shipmentId?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseGetPlanInfoDetailResponse
     */
    shippedDate?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseGetPlanInfoDetailResponse
     */
    shopName?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseGetPlanInfoDetailResponse
     */
    startDate?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponseGetPlanInfoDetailResponse
     */
    status?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponseGetPlanInfoDetailResponse
     */
    transportationOptionId?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponseGetPlanInfoDetailResponse
     */
    userId?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponseGetPlanInfoDetailResponse
     */
    userName?: string;
}

/**
 * Check if a given object implements the ResponseGetPlanInfoDetailResponse interface.
 */
export function instanceOfResponseGetPlanInfoDetailResponse(value: object): value is ResponseGetPlanInfoDetailResponse {
    return true;
}

export function ResponseGetPlanInfoDetailResponseFromJSON(json: any): ResponseGetPlanInfoDetailResponse {
    return ResponseGetPlanInfoDetailResponseFromJSONTyped(json, false);
}

export function ResponseGetPlanInfoDetailResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseGetPlanInfoDetailResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'amazonItems': json['amazon_items'] == null ? undefined : ((json['amazon_items'] as Array<any>).map(ResponseAmazonItemFromJSON)),
        'baseId': json['base_id'] == null ? undefined : json['base_id'],
        'endDate': json['end_date'] == null ? undefined : json['end_date'],
        'groupNum': json['group_num'] == null ? undefined : json['group_num'],
        'isApiPlan': json['is_api_plan'] == null ? undefined : json['is_api_plan'],
        'phoneNumber': json['phone_number'] == null ? undefined : json['phone_number'],
        'planId': json['plan_id'] == null ? undefined : json['plan_id'],
        'planName': json['plan_name'] == null ? undefined : json['plan_name'],
        'readyToShipDate': json['ready_to_ship_date'] == null ? undefined : json['ready_to_ship_date'],
        'senderName': json['sender_name'] == null ? undefined : json['sender_name'],
        'shipNum': json['ship_num'] == null ? undefined : json['ship_num'],
        'shipmentBoxes': json['shipment_boxes'] == null ? undefined : ((json['shipment_boxes'] as Array<any>).map(ResponseShipmentPackageFromJSON)),
        'shipmentConfirmationId': json['shipment_confirmation_id'] == null ? undefined : json['shipment_confirmation_id'],
        'shipmentId': json['shipment_id'] == null ? undefined : json['shipment_id'],
        'shippedDate': json['shipped_date'] == null ? undefined : json['shipped_date'],
        'shopName': json['shop_name'] == null ? undefined : json['shop_name'],
        'startDate': json['start_date'] == null ? undefined : json['start_date'],
        'status': json['status'] == null ? undefined : json['status'],
        'transportationOptionId': json['transportation_option_id'] == null ? undefined : json['transportation_option_id'],
        'userId': json['user_id'] == null ? undefined : json['user_id'],
        'userName': json['user_name'] == null ? undefined : json['user_name'],
    };
}

export function ResponseGetPlanInfoDetailResponseToJSON(json: any): ResponseGetPlanInfoDetailResponse {
    return ResponseGetPlanInfoDetailResponseToJSONTyped(json, false);
}

export function ResponseGetPlanInfoDetailResponseToJSONTyped(value?: ResponseGetPlanInfoDetailResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'amazon_items': value['amazonItems'] == null ? undefined : ((value['amazonItems'] as Array<any>).map(ResponseAmazonItemToJSON)),
        'base_id': value['baseId'],
        'end_date': value['endDate'],
        'group_num': value['groupNum'],
        'is_api_plan': value['isApiPlan'],
        'phone_number': value['phoneNumber'],
        'plan_id': value['planId'],
        'plan_name': value['planName'],
        'ready_to_ship_date': value['readyToShipDate'],
        'sender_name': value['senderName'],
        'ship_num': value['shipNum'],
        'shipment_boxes': value['shipmentBoxes'] == null ? undefined : ((value['shipmentBoxes'] as Array<any>).map(ResponseShipmentPackageToJSON)),
        'shipment_confirmation_id': value['shipmentConfirmationId'],
        'shipment_id': value['shipmentId'],
        'shipped_date': value['shippedDate'],
        'shop_name': value['shopName'],
        'start_date': value['startDate'],
        'status': value['status'],
        'transportation_option_id': value['transportationOptionId'],
        'user_id': value['userId'],
        'user_name': value['userName'],
    };
}

